import styled from 'styled-components';
import SecondaryButton from '@carvana/showroom-forms/Button/Secondary';
import { LinkWithNativeEvents } from '../link/link';

// header

export const HundredDayHeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin: 0;
  width: 100%;
  max-width: 1800px;
  background: #ffffff;
  position: relative;
`;

export const HundredDayHeaderLeftSideWrapper = styled.div`
  display: flex;
  width: 100%;
`;
export const HundredDayHeaderRightSideWrapper = styled.span`
  position: absolute;
  right: 0;
`;

export const HundredDayHeaderTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background: #ffffff;
  text-align: left;
`;

// content

export const HundredDayContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-wrap: wrap;
  margin: 0 auto;
  max-width: 1800px;
  background: #ffffff;

  @media (min-width: 668px) {
    flex-wrap: nowrap;
  }

  @media (min-width: 768px) {
    flex-direction: row;
  }
`;
export const HundredDayContentLeftSideWrapper = styled.span`
  display: flex;
  flex-direction: row;

  @media (min-width: 768px) {
    margin-right: 40px;
  }
`;
export const HundredDayContentRightSideWrapper = styled.span`
  display: flex;
  flex-direction: row;
  width: 100%;

  @media (min-width: 768px) {
    width: auto;
  }
`;
export const HundredDayContentTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  // max-width: 475px;
  background: #ffffff;
  font-size: 14px;
  line-height: 20px;
`;
export const HundredDaysContentWarrantiesRow = styled.div`
  display: flex;
  flex-direction: row;
  align-content: center;
  width: 100%;
  margin: 0 auto 16px auto;
  max-width: 1800px;
  background: #ffffff;

  @media (min-width: 769px) {
    flex-direction: row;
  }
`;

// text

export const HundredDayBoldText = styled.span`
  font-weight: 700;
  color: #183558;
`;
export const HundredDayText = styled.span`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #6d7184;
`;
export const HundredDayExpiredText = styled.span`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  padding-left: 0;
  line-height: 20px;
  color: #6d7184;
`;

export const HundredDayGreyText = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  padding: 2px;
  line-height: 20px;
  color: #6d7184;
  background: #f4f8fa;
  border-radius: 3px;

  @media (max-width: 767px) {
    text-align: center;
  }

  @media (min-width: 768px) {
    padding: 2px 16px;
  }
`;

export const HundredDayLinkText = styled(LinkWithNativeEvents)`
  text-decoration: underline;
  color: ${(props) => props.theme.color.primary.v200};
  white-space: nowrap;
  cursor: pointer;
`;

// button

export const HundredDayContentButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  width: 100%;
  margin-top: 24px;

  @media (min-width: 768px) {
    margin-top: 0;
  }
`;

export const HundredDayButton = styled(SecondaryButton)`
  display: flex;
  padding: 12px 24px;
  min-width: auto !important;
  min-height: 40px;
  font-size: 14px;
  line-height: 16px;
  text-transform: uppercase;

  @media (min-width: 376px) {
    min-width: 200px;
  }

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    min-width: 200px !important;
  }
`;

// miscellaneous

export const HundredDayChevronIconWrapper = styled.span<{ isOpen: any }>`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding-top: 6px;
  // padding-right: 12px;

  & svg {
    transition: transform 0.5s;
    transform: ${(props) => (props.isOpen === true ? 'rotate(180deg)' : 'rotate(0deg)')};
  }
`;
export const HundredDayTitle = styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  color: #183558;
  margin-bottom: 16px;
`;
export const HundredDayRowExpiredWarrantyWrapper = styled.span`
  display: block;
`;
export const HundredDayRowWarrantyWrapper = styled.div`
  /* Mobile devices */
  @media (max-width: 767px) {
    width: 100%;
  }

  /* Tablets and above */
  @media (min-width: 768px) {
    display: flex;
  }
`;

export const HideText = styled.span`
  @media (max-width: 375px) {
    display: none;
  }
`;
